import MenuItemCotizacion from '@/components/MenuItemCotizacion.vue';

export const headers = [
  {
    headerName: 'id Solución',
    field: 'id_solucion',
    sortable: false,
    resizable: true,
    minWidth: 120,
    hide: true,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Solución',
    field: 'nombre_solucion',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Modo',
    field: 'modalidad',
    sortable: false,
    resizable: true,
    minWidth: 50,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Cant',
    field: 'cantidad',
    sortable: false,
    resizable: true,
    minWidth: 50,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Plazo',
    field: 'plazo',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Precio',
    field: 'venta',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Servicio',
    field: 'servicio',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Arriendo',
    field: 'arriendo',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Instalación',
    field: 'instalacion',
    sortable: false,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Total Inversión Inicial',
    field: 'total_inversion',
    sortable: false,
    resizable: true,
    minWidth: 180,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Total Servicio Mes',
    field: 'total_servicio',
    sortable: false,
    resizable: true,
    minWidth: 180,
    lockPinned: true,
    cellStyle: {
      cursor: 'pointer',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
    },
  },
  {
    headerName: 'Acciones',
    width: 100,
    minWidth: 100,
    sortable: false,
    resizable: false,
    filter: false,
    enablePivot: false,
    field: 'id',
    cellRendererFramework: MenuItemCotizacion,
    cellRendererParams: (params: any) => {
      return {
        data: params.data,
        typeModal: 'detalleCotizacion',
      };
    },
    colId: 'params',
    rowDrag: false,
    pinned: 'right',
    lockVisible: true,
    suppressMovable: true,
    getQuickFilterText: () => '',
  },
];
